// extracted by mini-css-extract-plugin
module.exports = {"dottedCardWrapper":"dotted-card-bg_dottedCardWrapper__1UHuD"};